import { Anchor, ExternalLinkSVG, Icon } from "@newsela/angelou";

import {
  anchorCss,
  cardCss,
  descriptionCss,
  externalLinkIconCss,
  infoCss,
  lockedPageContainerCss,
  titleCss,
} from "@/browse/LockedContentPage/LockedContentPage.styles";
import { getLockedContentInfo } from "@/browse/LockedContentPage/LockedContentPage.utils";
import { LockedIconSvg } from "@/browse/LockedContentPage/LockedPageSvg";

const LockedContentPage = ({ slug }: ILockedContentPage) => {
  const { href, subscription, description } = getLockedContentInfo(slug);

  return (
    <div css={lockedPageContainerCss}>
      <div css={cardCss}>
        <Icon SvgComponent={LockedIconSvg} />
        <div css={infoCss}>
          <div css={titleCss}>Subscription required: {subscription}</div>
          <div css={descriptionCss}>{description}</div>

          <Anchor __cssFor={anchorCss} href={href}>
            Learn more
            <Icon
              __cssFor={externalLinkIconCss}
              SvgComponent={ExternalLinkSVG}
            />
          </Anchor>
        </div>
      </div>
    </div>
  );
};

interface ILockedContentPage {
  slug: string;
}

LockedContentPage.displayName = "LockedContentPage";
export { LockedContentPage };
